export const GET_ORGANIZATION_CONTACT = "GET_ORGANIZATION_CONTACT"
export const CREATE_ORGANIZATION_CONTACT = "CREATE_ORGANIZATION_CONTACT"
export const UPDATE_ORGANIZATION_CONTACT = "UPDATE_ORGANIZATION_CONTACT"
export const REMOVE_ORGANIZATION_CONTACT = "REMOVE_ORGANIZATION_CONTACT"
